import React, { useState, useEffect } from 'react';
import './App.css';

const Form = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [sid, setSid] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [response, setResponse] = useState('');
  const [error, setError] = useState(null);
  const [currentDate, setCurrentDate] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();

    // Собираем введенные параметры в JSON
    const data = {
      name,
      description,
      sid,
      from: from || '1970-01-01', // Проверка на пустое поле from
      to,
    };

    // Отправляем JSON на сервер
    fetch('http://185.66.85.168/generateLicense', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'success') {
            // Успешный результат
            setResponse(data.result);
          } else {
            // Ошибка
            setError(data.message);
            setTimeout(() => {
              setError(null);
            }, 3000);
          }
        })
        .catch((error) => {
          console.error('Ошибка:', error);
        });
  };

  const handleDownload = () => {
    const fileName = sid + '.lic';
    const element = document.createElement('a');
    const file = new Blob([response], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    element.click();
  };

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setCurrentDate(formattedDate);
  }, []);

  return (
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description:</label>
            <input
                type="text"
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="sid">SID:</label>
            <input
                type="text"
                id="sid"
                value={sid}
                onChange={(e) => setSid(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="from">From:</label>
            <input
                type="text"
                id="from"
                value={from || currentDate}
                onChange={(e) => setFrom(e.target.value)}
                placeholder="YYYY-MM-DD"
                autoComplete="off"
            />
          </div>
          <div className="form-group">
            <label htmlFor="to">To:</label>
            <input
                type="text"
                id="to"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                placeholder="YYYY-mm-dd"
            />
          </div>
          <button type="submit">Generate</button>
        </form>
        {response && (
            <div className="response-main-container">
              <button id="downloadButton" onClick={handleDownload}>Download .lic</button>
              <div className="response-container">
                <h3>Response:</h3>
                <pre>{response}</pre>
              </div>
            </div>
        )}
        {error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
        )}
      </div>
  );
};

export default Form;
